// extracted by mini-css-extract-plugin
export var text = "_aj-0";